/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function TextHFive(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0ZM211.88184,140.002a36.413,36.413,0,0,0-9.33985,1.209L206.63965,116H240a8,8,0,0,0,0-16H199.835a8.00076,8.00076,0,0,0-7.89648,6.7168l-7.835,48.20215a7.99971,7.99971,0,0,0,13.541,6.95214,20.20412,20.20412,0,0,1,28.47461-.001,19.91646,19.91646,0,0,1,.001,28.25976,20.20173,20.20173,0,0,1-28.47461.001,7.99985,7.99985,0,1,0-11.291,11.33594A36.05843,36.05843,0,1,0,211.88184,140.002Z" />
    </Svg>
  );
}

export default TextHFive;
